import './SegmentedControl.css';

export interface SegmentedControlOption<T extends string = string> {
  label: string;
  value: T;
}

export interface SegmentedControlProps<T extends string = string> {
  options: SegmentedControlOption<T>[];
  value: T;
  onValueChange: (value: T) => void;
  className?: string;
  textVariant?: 'body' | 'caption';
}

export function SegmentedControl<T extends string = string>({
  options,
  value,
  onValueChange,
  className = '',
  textVariant = 'body',
}: SegmentedControlProps<T>) {
  return (
    <div
      className={`segmented-control ${textVariant === 'caption' ? 'segmented-control-caption' : ''} ${className}`}
      role="radiogroup"
    >
      {options.map((option, index) => {
        const isSelected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onValueChange(option.value)}
            className={`segmented-control-option ${isSelected ? 'segmented-control-option-selected' : ''} ${index < options.length - 1 ? 'segmented-control-option-spaced' : ''}`}
            role="radio"
            aria-checked={isSelected}
            aria-label={option.label}
          >
            <span className={`segmented-control-label ${textVariant === 'caption' ? 'segmented-control-label-caption' : ''}`}>
              {option.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
